import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { isEmpty } from 'lodash';
import { getTimeSalutation, toTitleCase } from '../../../utils/helpers';
import { SplashScreen } from '../SplashScreen';
import resourcesConfig from '../../../resources';

import './RewardsGreeting.scss';

const currentTime = new Date();

export const RewardsGreeting = ({
  active,
  type,
  timeout,
  direction,
  onEntered,
  onExited,
  splashDuration,
  splashBgColor,
  splashBgImage,
  textColor,
  deactivate,
  showTimeSalutation,
  loggedInGuestName,
  showGreeterText,
  brandSprite,
  greeterHTML,
  showStaticGreeter,
}) => {
  const [sprite, setSprite] = useState();
  const containerRef = useRef(null);

  useEffect(() => {
    if (brandSprite) {
      let newSprite = new Image();
      newSprite.src = brandSprite;
      setSprite(newSprite);
    }
  }, [brandSprite]);

  const baseAnimationProps = {
    type,
    timeout,
    direction,
    onEntered,
    onExited,
  };

  const splashScreenProps = {
    active,
    bgColor: splashBgColor,
    textColor,
    containerRef,
    splashDuration,
    deactivate,
  };

  const timeSalutation = getTimeSalutation(currentTime);
  let guestNameElem = document.getElementById('greeter-guest-name');
  let timeSalElem = document.getElementById('time-salutation');
  let greeterContentElem = document.getElementById('greeter-content');
  let isGuestNameSet = guestNameElem && guestNameElem.hasChildNodes();

  useEffect(() => {
    if (showStaticGreeter && guestNameElem && !isEmpty(loggedInGuestName)) {
      guestNameElem.innerHTML = toTitleCase(loggedInGuestName);
    }
  }, [guestNameElem, loggedInGuestName, showStaticGreeter]);

  useEffect(() => {
    if (showStaticGreeter && greeterContentElem && guestNameElem && isGuestNameSet) {
      greeterContentElem.style['display'] = 'block';
    }
  }, [guestNameElem, greeterContentElem, isGuestNameSet, showStaticGreeter]);

  useEffect(() => {
    if (showStaticGreeter && timeSalElem) {
      if (showTimeSalutation) {
        timeSalElem.innerHTML = timeSalutation;
      } else {
        timeSalElem.remove();
      }
    }
  }, [timeSalElem, showStaticGreeter]);

  return (
    <div className="rewards-greeting-splash-screen" ref={containerRef}>
      <SplashScreen {...splashScreenProps} baseAnimation={baseAnimationProps} brandSprite={sprite}>
        {showStaticGreeter ? (
          <div
            className="rewards-greeting-splash-screen"
            dangerouslySetInnerHTML={{
              __html: greeterHTML,
            }}
          />
        ) : (
          <>
            <div className={classNames('rewards-greeting-splash-screen_bg-image-wrapper')}>
              {splashBgImage && <img src={splashBgImage} alt="" className="bg-image" />}
            </div>
            <div className={classNames('rewards-greeting-splash-screen_content')}>
              <img
                className="meroha-logo"
                src="/brand/meroha-logo.png"
                alt="Meroha — on your behalf"
              />
              {showGreeterText && (
                <>
                  {showTimeSalutation && <div className="time-salutation">{timeSalutation}</div>}
                  {loggedInGuestName && (
                    <div className="guest-name">{toTitleCase(loggedInGuestName)}</div>
                  )}
                  {loggedInGuestName && (
                    <div>
                      <FormattedMessage
                        id="greeterContent"
                        defaultMessage={resourcesConfig.greeterContent}
                        values={{
                          br: <br />,
                        }}
                      />
                    </div>
                  )}
                </>
              )}
            </div>
          </>
        )}
      </SplashScreen>
    </div>
  );
};

RewardsGreeting.defaultProps = {
  active: false,
  type: 'fade',
  timeout: { appear: 0, enter: 0, exit: 1200 }, // ms
  direction: 'left',
  onEntered: () => {},
  onExited: () => {},
  textColor: '#463129',
  splashBgImage: '',
  splashDuration: 4000, // ms
  deactivate: () => {},
  showTimeSalutation: true,
};
